module.exports = __webpack_public_path__ + "img/antes_despues_266.66bac73c.png";